import { Component, OnInit } from '@angular/core';
import { GetdataService } from '../../services/getdata.service';
import { Router } from '@angular/router';
import { FlashMessagesModule, FlashMessagesService } from 'angular2-flash-messages';
declare var $ :any;

@Component({
  selector: 'app-trafalgar-event-total-view',
  templateUrl: './trafalgar-event-total-view.component.html',
  styleUrls: ['./trafalgar-event-total-view.component.css']
})
export class TrafalgarEventTotalViewComponent implements OnInit {

  meetingData:object;
  roomData:object;

  constructor(private getdataService:GetdataService, private router:Router,private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {


      
    this.getdataService.getEventsByAccountID("5b8c1a2da9a50c0759567842").subscribe((meetingdata) => {
      this.meetingData =[];
      for(let i=0; i<meetingdata.length; i++){
        this.meetingData[i]={title:'',resourceId:'',id:'',start:0,end:0}
        this.meetingData[i].title = meetingdata[i].event_name;
        this.meetingData[i].resourceId = meetingdata[i].event_room_id;
        this.meetingData[i].id = meetingdata[i]._id;
        this.meetingData[i].start = meetingdata[i].event_start_time;
        this.meetingData[i].end = meetingdata[i].event_end_time;
      }
      $('#calendar').fullCalendar({
        defaultView: 'agendaDay',
        allDaySlot: false,
        events: this.meetingData ,
        eventClick: (calEvent, jsEvent, view) => {
          this._flashMessagesService.show('Editing Event:'+calEvent.title, {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

          this.router.navigate(['/admin/edittrafalgarevents/', calEvent.id]);
        
      
       },
        resources: [
          { id: '5b8c1e4ea573200ae60eab53', title: 'Arena' },
          { id: '5b8c1dd1a573200ae60eab4e', title: 'Gymnasium' },
          { id: '5b8c1dbba573200ae60eab4d', title: 'Gymnasium West' },
          { id: '5b8c1da7a573200ae60eab4c', title: 'Gymnasium East' },
          { id: '5b8c1de3a573200ae60eab4f', title: 'Indoor Track' },
          { id: '5b8c1d9ca573200ae60eab4b', title: 'Kinsmen Pine Room' },
          { id: '5b8c1d4ca573200ae60eab49', title: 'Kinsmen Pine Room 1' },
          { id: '5b8c1d7ba573200ae60eab4a', title: 'Kinsmen Pine Room 2' },
          { id: '5b8c1c189ef52a0a1c748cf8', title: 'Multipurpose 1' },
          { id: '5b8c1ce0a573200ae60eab47', title: 'Multipurpose 2' },
          { id: '5b8c1cf7a573200ae60eab48', title: 'Multipurpose 3' },
          { id: '5b8c1df8a573200ae60eab50', title: 'Atrium' },
          { id: '5b8c1e0da573200ae60eab51', title: 'Quiet Lounge' },
          { id: '5b8c1e23a573200ae60eab52', title: 'Bistro' }
        ]
      });
      // this.getdataService.getMeetingRoomsByAccount("5b8b22085e845a26c47b173c").subscribe((roomdata) => {
      //   for(let i=0; i<roomdata.length; i++){
      //     this.roomData[i]={id:'',title:''}
      //     this.roomData[i].id = roomdata[i]._id;
      //     this.roomData[i].title = roomdata[i].room_name;
      //   }
     
      // },
      // err=>{
      //   //////console.log(err);
      //   return false;
      // });
      ////console.log(this.meetingData);
   
    },
    err=>{
      //////console.log(err);
      return false;
    });

     // [
      //   {title:"event at Arena", start:1537913353873, end:1537993368256, resourceId:"Arena"},
      //   {title:"event at Arena", start:1537913353873, end:1537993368256, resourceId:"Kinsmen_Pine_Room_2"}
      // ]

   
  }

}



// WEBPACK FOOTER //
// ./src/app/components/trafalgar-event-total-view/trafalgar-event-total-view.component.ts